/**
 * Possible values for `contract.billing.billableItemsGeneration`.
 * CONTRACT_RATES -> show the Rate Cards tab.
 * ASSIGNEE_QUOTED_FARE -> show the Invoiced Rates tab.
 */
export const BILLING_TYPE = Object.freeze({
  CONTRACT_RATES: 'contract.rates',
  ASSIGNEE_QUOTED_FARE: 'assignee.quotedFare',
});

/**
 * Human-readable labels for each billing type. Use for user-facing rendering
 * (e.g. the Activity Log) instead of the raw `billableItemsGeneration` path value.
 */
export const BILLING_TYPE_LABELS = Object.freeze({
  [BILLING_TYPE.CONTRACT_RATES]: 'Rates',
  [BILLING_TYPE.ASSIGNEE_QUOTED_FARE]: 'Invoiced Rates',
});
